import { PNGS, SVGS } from '@zonofi/zono-money-design-system';
import React, { useState } from 'react';
import './product-details-image-gallery-v2.scss';
interface ProductDetailsImageGalleryV2Props {
  images: string[];
  setShowImageGallery: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ProductDetailsImageGalleryV2: React.FC<
  ProductDetailsImageGalleryV2Props
> = ({ images, setShowImageGallery }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const minSwipeDistance = 50;

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setTouchStart(e.touches[0].clientX);
    setTouchEnd(null);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    setTouchEnd(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart === null || touchEnd === null) return;

    const distance = touchStart - touchEnd;

    if (distance > minSwipeDistance) {
      setCurrentImage((prev) => (prev + 1) % images.length);
    } else if (distance < -minSwipeDistance) {
      setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
    }

    setTouchStart(null);
    setTouchEnd(null);
  };
  const getModifiedImageUrl = (url: string) => {
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set('width', '512');
      urlObj.searchParams.delete('height');
      return urlObj.toString();
    } catch {
      return url;
    }
  };
  return (
    <div
      className="product-gallery-v2"
      onClick={() => setShowImageGallery(true)}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="product-gallery-v2-images">
        <img
          src={getModifiedImageUrl(images[currentImage]) || SVGS.DefaultProduct}
          alt=""
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = SVGS.DefaultProduct;
          }}
        />
        {/* <img
          src={PNGS.RosePinkImage}
          alt=""
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = SVGS.DefaultProduct;
          }}
        /> */}
      </div>

      {/* <div className="image-dots">
        {images.length > 1 &&
          images.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentImage === index ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentImage(index);
              }}
            />
          ))}
      </div> */}
      <div className="product-gallery-v2-header">
        <span className="product-gallery-v2-header-text font-primary-semibold">
          Select to add variant to cart
        </span>
      </div>
    </div>
  );
};
